export enum S3_PATH_TYPE {
  AGENCY_LOGO = 'AGENCY_LOGO',
  BANNER = 'BANNER',
  BEST_CONTENTS = 'BEST_CONTENTS',
  BLOG_CONTENTS = 'BLOG_CONTENTS',
  CARD_ISSUE = 'CARD_ISSUE',
  CIVIL_DOCUMENT = 'CIVIL_DOCUMENT',
  CIVIL_DOCUMENT_LOGO = 'CIVIL_DOCUMENT_LOGO',
  COMMUNITY = 'COMMUNITY',
  COMPANY_LOGO = 'COMPANY_LOGO',
  EASY_APPLY_SIGN = 'EASY_APPLY_SIGN',
  FAQ = 'FAQ',
  HOMETOWN_NEWS = 'HOMETOWN_NEWS',
  HOME_GIFT_PRODUCT_THUMBNAIL = 'HOME_GIFT_PRODUCT_THUMBNAIL',
  HOME_GIFT_PRODUCT_SUB_IMAGE = 'HOME_GIFT_PRODUCT_SUB_IMAGE',
  HOME_GIFT_PRODUCT_CONTENT_IMAGE = 'HOME_GIFT_PRODUCT_CONTENT_IMAGE',
  /** 지자체 게시판 템플릿 이미지 */
  HOME_INSTITUTION_BOARD_TEMPLATE_IMAGE = 'HOME_INSTITUTION_BOARD_TEMPLATE_IMAGE',
  HOME_INSTITUTION_LOGO = 'HOME_INSTITUTION_LOGO',
  HOME_INSTITUTION_FILE = 'HOME_INSTITUTION_FILE',
  HOME_INSTITUTION_CONTENT_THUMBNAIL = 'HOME_INSTITUTION_CONTENT_THUMBNAIL',
  HOME_INSTITUTION_EVENT_THUMBNAIL = 'HOME_INSTITUTION_EVENT_THUMBNAIL',
  HOME_INSTITUTION_EVENT_OG_IMAGE = 'HOME_INSTITUTION_EVENT_OG_IMAGE',
  HOME_ORDER_PRODUCT_REVIEW = 'HOME_ORDER_PRODUCT_REVIEW',
  LOCAL_MARKET_PRODUCT_REVIEW = 'LOCAL_MARKET_PRODUCT_REVIEW',
  LOCAL_MARKET_PRODUCT_RETURN = 'LOCAL_MARKET_PRODUCT_RETURN',
  LOCAL_MARKET_PRODUCT_EXCHANGE = 'LOCAL_MARKET_PRODUCT_EXCHANGE',
  HOME_VENDOR_BUSINESS_FILE = 'HOME_VENDOR_BUSINESS_FILE',
  HOME_VENDOR_DEPOSIT_ACCOUNT_FILE = 'HOME_VENDOR_DEPOSIT_ACCOUNT_FILE',
  HOME_INQUIRY = 'HOME_INQUIRY',
  HOME_LOVE_EDITOR = 'HOME_LOVE_EDITOR',
  HOME_GIFT_SETTLEMENT = 'HOME_GIFT_SETTLEMENT',
  INQUIRY = 'INQUIRY',
  INSTITUTION = 'INSTITUTION',
  INSTITUTION_LOGO = 'INSTITUTION_LOGO',
  HOME_DONATION_BUSINESS = 'HOME_DONATION_BUSINESS',
  INTERNAL = 'INTERNAL',
  KB_WELLO_POLICY = 'KB_WELLO_POLICY',
  MEMBER_PROFILE_IMAGE = 'MEMBER_PROFILE_IMAGE',
  META_BUSINESS = 'META_BUSINESS',
  NOTICE = 'NOTICE',
  POLICY_EASY_APPLY = 'POLICY_EASY_APPLY',
  PRODUCT = 'PRODUCT',
  SERVICE_NOTICE = 'SERVICE_NOTICE',
  SITUATION = 'SITUATION',
  SUBSTITUTE = 'SUBSTITUTE',
  SURVEY = 'SURVEY',
  TEMP = 'TEMP',
  TERM = 'TERM',
  WELCOME_MONITOR = 'WELCOME_MONITOR',
  WELLO_HELPER = 'WELLO_HELPER',
  WELLO_PICK = 'WELLO_PICK',
  WELLO_TOUR_REVIEW = 'WELLO_TOUR_REVIEW',
  POINT_MALL_PRODUCT = 'POINT_MALL_PRODUCT',
  POINT_MALL_SHOWCASE = 'POINT_MALL_SHOWCASE',
}

export enum S3_CDN_TYPE {
  /** 암호화 필요 없는 단순 이미지 */
  WELFARE_HELLO = 'S3_CDN_TYPE_WELFAREHELLO',
  /** 암호화 필요한 이미지 */
  ENCRYPT = 'S3_CDN_TYPE_ENCRYPT',
}
